import { Injectable } from '@angular/core';
import { User } from 'src/app/core/model/user-model';
import { LogoutService } from './logout.service';

@Injectable({
  providedIn: 'root',
})
export class UserDataService {
  constructor(private logoutService: LogoutService) {}

  public getUser(): Promise<User> {
    const userJson = localStorage.getItem('user');
    const user = User.fromJSON(userJson);
    if (user) {
      return Promise.resolve(user);
    } else {
      this.logoutService.logout();
    }
  }

  public saveUser(user: User) {
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('userUpdatedAt', new Date().toISOString());
  }

  public removeUser() {
    localStorage.setItem('user', '');
  }

  public getToken() {
    return localStorage.getItem('token');
  }

  public saveToken(token: string) {
    localStorage.setItem('token', token);
  }

  public removeToken() {
    localStorage.setItem('token', '');
  }

  public getRefreshToken() {
    return localStorage.getItem('refresh-token');
  }

  public saveRefreshToken(token: string) {
    localStorage.setItem('refresh-token', token);
  }

  public removeRefreshToken() {
    localStorage.setItem('refresh-token', '');
  }

  public getHeaderDict() {
    const authorization = 'Bearer ' + this.getToken();
    const headerDict = {
      Authorization: authorization,
      'x-deviceType': 'pwa',
      'x-versionCode': '81',
    };
    return headerDict;
  }
}
